import React, { useEffect, useState, useRef }  from 'react';
import '../styles/calendar_views.css';

const CalendarViews = (props) => {

    return(
        <>
            <div className="sectionTitleCalendarView">WIDOKI</div>
            <div className="mainContainerCalendarViews">
                <button className="colCalendarViews" value="year" onClick={props.setView}>
                    ROCZNY
                </button>
                <button className="colCalendarViews" value="month" onClick={props.setView}>
                    MIESIĘCZNY
                </button>
                <button className="colCalendarViews" value="week" onClick={props.setView}>
                    TYGODNIOWY
                </button>
                <button className="colCalendarViews" value="daily" onClick={props.setView}>
                    DZIENNY
                </button>
            </div>
        </>
    )

}

export default CalendarViews;